// Copyright (c) 2016 Deere & Company

import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import Recommendation, {getDefaultState as getRecommendationState} from './recommendation';
import TimestampUser, {getDefaultState as getTimestampUserDefaultState} from './timestamp-user';
import TransferProduct, {getDefaultState as getTransferProductDefaultState} from './transfer-product';
import t from 'tcomb';

const DealerRecommendationLeaveAor = t.struct({
    approverComment: t.maybe(t.String),
    currentDealer: Dealer,
    id: t.String,
    isEnterAOR: t.maybe(t.Boolean),
    isRecommendation:t.maybe(t.Boolean),
    newDealer: Dealer,
    product: TransferProduct,
    reasonForChange: t.String,
    recommendation: t.maybe(Recommendation),
    requestDate: t.Number,
    requestedBy: TimestampUser,
    status: t.String
}, {
    name: 'DealerRecommendationLeaveAor',
    strict: true
});

export const getDefaultState = () => new DealerRecommendationLeaveAor({
    currentDealer: getDealerDefaultState(),
    id: '',
    isEnterAOR: false,
    isRecommendation: false,
    newDealer: getDealerDefaultState(),
    product: getTransferProductDefaultState(),
    reasonForChange: '',
    recommendation: getRecommendationState(),
    requestDate: 0,
    requestedBy: getTimestampUserDefaultState(),
    status: ''
});

export default DealerRecommendationLeaveAor;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dealer-recommendation-leave-aor.js